import { render, staticRenderFns } from "./cancelclass.vue?vue&type=template&id=96a3c856&scoped=true"
import script from "./cancelclass.vue?vue&type=script&lang=js"
export * from "./cancelclass.vue?vue&type=script&lang=js"
import style0 from "./cancelclass.vue?vue&type=style&index=0&id=96a3c856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a3c856",
  null
  
)

export default component.exports